<div class="row">
  <div class="col-12">
    <h4 class="mt-0 text-center text-md-left" translate>CUSTOMER_TEMPLATES</h4>
    <hr>
  </div>
  <div class="col-12">
    <lib-company-templates-list></lib-company-templates-list>
  </div>
</div>
